import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
    BasicGasCalculation,
    SpecialPumpCalculationOutput,
} from "../../model/calculations/calculation";

interface State {
    loading: boolean;
    error: string | null;
    GKXCalculationData: SpecialPumpCalculationOutput | null;
    CP1CalculationData: SpecialPumpCalculationOutput | null;
    CP2CalculationData: SpecialPumpCalculationOutput | null;
    CP3CalculationData: SpecialPumpCalculationOutput | null;
    showGkxGraphControl: boolean;
    BasicGasCalculation: BasicGasCalculation | null;
    GKXPumpChangeData: any | null;
    gasHandlerData: SpecialPumpCalculationOutput | null;
    gasHandlerPumpID: string;
    gasHandlerPumpName: string;
}

export const initialState: State = {
    loading: false,
    error: null,
    GKXCalculationData: null,
    CP1CalculationData: null,
    CP2CalculationData: null,
    CP3CalculationData: null,
    showGkxGraphControl: false,
    BasicGasCalculation: null,
    GKXPumpChangeData: null,
    gasHandlerData: null,
    gasHandlerPumpID: "",
    gasHandlerPumpName: "",
};

const gasHandlerCalculationSlice = createSlice({
    name: "gasHandlerCalculation",
    initialState,
    reducers: {
        resetGasHandlerCalculation: () => ({
            ...initialState,
        }),
        setGKXCalculationData: (
            state,
            action: PayloadAction<SpecialPumpCalculationOutput | null>
        ) => {
            state.GKXCalculationData = action.payload;
        },
        setCP1CalculationData: (
            state,
            action: PayloadAction<SpecialPumpCalculationOutput | null>
        ) => {
            state.CP1CalculationData = action.payload;
        },

        setCP1FinalTDH: (state, action: PayloadAction<any>) => {
            if (state.CP1CalculationData) {
                state.CP1CalculationData.finalTDH = action.payload;
            }
        },
         setCP2FinalTDH: (state, action: PayloadAction<any>) => {
            if (state.CP2CalculationData) {
                state.CP2CalculationData.finalTDH = action.payload;
            }
        },
         setCP3FinalTDH: (state, action: PayloadAction<any>) => {
            if (state.CP3CalculationData) {
                state.CP3CalculationData.finalTDH = action.payload;
            }
        },

        setCP2CalculationData: (
            state,
            action: PayloadAction<SpecialPumpCalculationOutput | null>
        ) => {
            state.CP2CalculationData = action.payload;
        },
        setCP3CalculationData: (
            state,
            action: PayloadAction<SpecialPumpCalculationOutput | null>
        ) => {
            state.CP3CalculationData = action.payload;
        },
        setShowGkxGraphControl: (state, action: PayloadAction<boolean>) => {
            state.showGkxGraphControl = action.payload;
        },
        setGKXPumpChangeData: (state, action: PayloadAction<any>) => {
            state.GKXPumpChangeData = action.payload;
        },
        setGasHandlerData: (state, action: PayloadAction<any>) => {
            state.gasHandlerData = action.payload;
        },
        setGasHandlerPumpID: (state, action: PayloadAction<string>) => {
            state.gasHandlerPumpID = action.payload;
        },
        setGasHandlerPumpName: (state, action: PayloadAction<string>) => {
            state.gasHandlerPumpName = action.payload;
        },
    }
});

export const {
    resetGasHandlerCalculation,
    setGKXCalculationData,
    setCP1CalculationData,
    setCP2CalculationData,
    setCP3CalculationData,
    setShowGkxGraphControl,
    // setGKXData,
    setGKXPumpChangeData,
    setGasHandlerData,
    setGasHandlerPumpID,
    // setGasHandlerCorrectionFactors,
    setGasHandlerPumpName,
    setCP1FinalTDH,
    setCP2FinalTDH,
    setCP3FinalTDH
} = gasHandlerCalculationSlice.actions;

export default gasHandlerCalculationSlice.reducer;
